"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSymbols = exports.mapSearchParam = exports.fetchBannerMarketDetail = exports.fetchPromoDetail = exports.fetchBannerDetail = exports.fetchMarket = exports.fetchProducts = exports.fetchCategoryDetails = exports.fetchProvinces = exports.fetchCategories = exports.wishListRemove = exports.wishListAdd = void 0;
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("./constants");
var query_string_1 = __importDefault(require("query-string"));
var merchantBaseUrl = process.env.MIX_LADARA_MERCHANT_BASE_URL;
var adminBaseUrl = process.env.MIX_APP_URL + '/';
var wishListAdd = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
    var wishlistApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.post(merchantBaseUrl + "api/wishlist", { product_id: productId }, {
                    withCredentials: true,
                })];
            case 1:
                wishlistApi = _a.sent();
                return [2 /*return*/, wishlistApi.data];
        }
    });
}); };
exports.wishListAdd = wishListAdd;
var wishListRemove = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
    var wishlistApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.delete(merchantBaseUrl + "api/wishlist/" + productId, {
                    withCredentials: true,
                })];
            case 1:
                wishlistApi = _a.sent();
                return [2 /*return*/, wishlistApi.data];
        }
    });
}); };
exports.wishListRemove = wishListRemove;
var fetchCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
    var categoriesApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(merchantBaseUrl + "api/categories/market", {
                    withCredentials: true,
                })];
            case 1:
                categoriesApi = _a.sent();
                return [2 /*return*/, categoriesApi.data];
        }
    });
}); };
exports.fetchCategories = fetchCategories;
var fetchProvinces = function () { return __awaiter(void 0, void 0, void 0, function () {
    var provincesApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(merchantBaseUrl + "api/address/get-recommended-province", {
                    withCredentials: true,
                })];
            case 1:
                provincesApi = _a.sent();
                return [2 /*return*/, provincesApi.data];
        }
    });
}); };
exports.fetchProvinces = fetchProvinces;
var fetchCategoryDetails = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var categoriesApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(merchantBaseUrl + "api/categories/" + id, {
                    withCredentials: true,
                })];
            case 1:
                categoriesApi = _a.sent();
                return [2 /*return*/, categoriesApi.data];
        }
    });
}); };
exports.fetchCategoryDetails = fetchCategoryDetails;
var fetchProducts = function (searchParam) { return __awaiter(void 0, void 0, void 0, function () {
    var initParam, param, mappedParams, productApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initParam = "&list_brand=1&list_category=1&list_location=1&limit=30";
                param = "?type=web&" + initParam;
                if (searchParam !== undefined) {
                    if (searchParam['is_gkp']) {
                        initParam = "&list_category=1&list_location=1&limit=10";
                        param = "?type=web&" + initParam;
                    }
                    mappedParams = exports.mapSearchParam(searchParam);
                    param = "?type=web&" + query_string_1.default.stringify(mappedParams, {
                        encode: false,
                    }) + initParam;
                }
                return [4 /*yield*/, axios_1.default.get(merchantBaseUrl + "api/v2/product/get/search/product/elastic" + param, {
                        withCredentials: true,
                    })];
            case 1:
                productApi = _a.sent();
                return [2 /*return*/, productApi.data];
        }
    });
}); };
exports.fetchProducts = fetchProducts;
var fetchMarket = function (market) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(merchantBaseUrl + "api/market/" + market, {
                    withCredentials: true,
                })];
            case 1: return [2 /*return*/, (_a.sent()).data];
        }
    });
}); };
exports.fetchMarket = fetchMarket;
var fetchBannerDetail = function (id, searchParam) { return __awaiter(void 0, void 0, void 0, function () {
    var param, mappedParams, productApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                param = '';
                if (searchParam !== undefined) {
                    mappedParams = exports.mapSearchParam(searchParam);
                    param = "?" + query_string_1.default.stringify(mappedParams, {
                        encode: false,
                    });
                }
                return [4 /*yield*/, axios_1.default.get(adminBaseUrl + "api/banner/" + id + param, {
                        withCredentials: true,
                    })];
            case 1:
                productApi = _a.sent();
                return [2 /*return*/, productApi.data];
        }
    });
}); };
exports.fetchBannerDetail = fetchBannerDetail;
var fetchPromoDetail = function (id, searchParam) { return __awaiter(void 0, void 0, void 0, function () {
    var param, mappedParams, productApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                param = '';
                if (searchParam !== undefined) {
                    mappedParams = exports.mapSearchParam(searchParam);
                    param = "?" + query_string_1.default.stringify(mappedParams, {
                        encode: false,
                    });
                }
                return [4 /*yield*/, axios_1.default.get(adminBaseUrl + "api/promo/detail/" + id + param, {
                        withCredentials: true,
                    })];
            case 1:
                productApi = _a.sent();
                return [2 /*return*/, productApi.data];
        }
    });
}); };
exports.fetchPromoDetail = fetchPromoDetail;
var fetchBannerMarketDetail = function (id, searchParam) { return __awaiter(void 0, void 0, void 0, function () {
    var param, mappedParams, productApi;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                param = '';
                if (searchParam !== undefined) {
                    mappedParams = exports.mapSearchParam(searchParam);
                    param = "?" + query_string_1.default.stringify(mappedParams, {
                        encode: false,
                    });
                }
                return [4 /*yield*/, axios_1.default.get(merchantBaseUrl + "api/market/banner/detail/" + id + param, {
                        withCredentials: true,
                    })];
            case 1:
                productApi = _a.sent();
                return [2 /*return*/, productApi.data];
        }
    });
}); };
exports.fetchBannerMarketDetail = fetchBannerMarketDetail;
var mapSearchParam = function (searchParam) {
    var newSearchParams = {};
    var map = constants_1.searchParamsMap;
    map.map(function (param) {
        var _a, _b, _c;
        var _d;
        if (searchParam[param.old]) {
            switch (param.old) {
                case "maxrange":
                case "minrange":
                    newSearchParams = __assign(__assign({}, newSearchParams), (_a = {}, _a[param.new] = JSON.stringify([
                        searchParam.minrange,
                        searchParam.maxrange,
                    ]), _a));
                    break;
                case "category":
                case "province":
                case "brand_id":
                    if (searchParam[param.old] !== "") {
                        newSearchParams = __assign(__assign({}, newSearchParams), (_b = {}, _b[param.new] = JSON.stringify((_d = searchParam[param.old]) === null || _d === void 0 ? void 0 : _d.split(",")), _b));
                    }
                    break;
                case "by":
                    if (searchParam.by === "termurah") {
                        newSearchParams = __assign(__assign({}, newSearchParams), { price: "asc" });
                        break;
                    }
                    else if (searchParam.by === "terkait") {
                        var newParam = newSearchParams;
                        delete newParam.price;
                        delete newParam.name;
                        newSearchParams = newParam;
                        break;
                    }
                    else {
                        newSearchParams = __assign(__assign({}, newSearchParams), { 
                            //@ts-ignore
                            name: searchParam[param.old] });
                        break;
                    }
                default:
                    newSearchParams = __assign(__assign({}, newSearchParams), (_c = {}, _c[param.new] = searchParam[param.old], _c));
                    break;
            }
        }
    });
    return newSearchParams;
};
exports.mapSearchParam = mapSearchParam;
var removeSymbols = function (str) {
    return str.replace(/[^\w\s]/gi, "");
};
exports.removeSymbols = removeSymbols;
